import React, { useState, useEffect }  from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { saveForm, getToken } from "../../../services/formServices";
import { navigate } from "gatsby-link";
import Modal from "../../molecules/modal/modal";
import Loading from "../../atoms/loading/loading";
import FormInput from "../../atoms/form-input/FormInput";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import arrowLeft from "../../../assets/images/icons/flecha-izq.png";
import warningSvg from "../../../assets/images/icons/icon-alert.svg";
import FormWizard from "../../molecules/form-wizard/FormWizard";
import ProgressBar from "../../atoms/progress-bar/progressBar";
import ToastAdvertiser from "../../atoms/toast-advertiser/toastAdvertiser";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import "./FormSolicitudServicios.scss";
import "./FormSolicitudServiciosV2.scss";

type Inputs = {
    example: string
    exampleRequired: string
    disabilityName: string
    contactNumber: string
    aditionalContactNumber: string
    countryCode: string
    aditionalCountryCode: string
}

interface ModalContent {
    title: string;
    image: string;
    textButton: string;
    url: string;
    description: string;
}

const FormSolicitudServiciosV2 = (props: any) => {
    const [wizards, setWizards] = useState<any[]>([]);
    const [activeStep, setActiveStep] = useState<number>(0);
    const [hasNoAuthorization, setHasNoAuthorization] = useState<boolean>(false);
    const [modalContent, setModalContent] = useState<ModalContent>();
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);
    const titulosFormulario = props?.referenciaFormularios[0]?.titulosFormulario ?? "";
    let pathNameFixed = "";

    const getPathSegments = () => {
        const pathname = window.location.pathname;
        const segments = pathname.split('/').filter(Boolean);
        pathNameFixed = `${segments.slice(-2).join('/')}`;
        return pathNameFixed;
    };
    
    const handleBack = () => {
        if (activeStep === 0) {
            navigate('../');
        } else {
            setActiveStep(activeStep - 1);
        }
    }

    const createWizards : () => void = () => {
        let newWizards: any[] = [];
        for (let i = 0; i < titulosFormulario.length; i++) {
            if (titulosFormulario[i]) {
                newWizards.push({
                    description: titulosFormulario[i].tituloSeccion,
                    idx: i,
                });
            }
        }
        
        setWizards([...newWizards]);
    };

    const handleModalContent = (status: number) => {
        if (status === 200) {
            setModalContent({
                title: 'Hemos recibido tu solicitud',
                image: '//images.ctfassets.net/203frbsx1z3n/zpQYvZwbGUcb16ZFwjOXR/f54d1f374a7099b522ebcb24287d2ac6/ChecCirculo.svg',
                textButton: 'Volver al inicio',
                url: '/empresas/',
                description: 'Muchas gracias por solicitar nuestros servicios. En un término de 48 horas te contactaremos para acompañarte.'
            });
        } else {
            setModalContent({
                title: 'Se ha presentado un problema',
                image: '//images.ctfassets.net/203frbsx1z3n/6m03XnZihvm3nFFlJzHZDF/9c139bd6b451a3a3eee76bd1fac29236/check-error.png',
                textButton: 'Aceptar',
                url: '/empresas/comunidades/',
                description: 'En este momento no podemos procesar su solicitud, por favor intentelo mas tarde.'
            });
        }
    };
    const createInputGroupRequiredList = () => {
        const inputList = [];
        props.referenciaFormularios[0].titulosFormulario.map((tituloFormulario) => {
            tituloFormulario.referenciaFormulario.map((input) => {
                if (!input.fieldMandatory || watchedValues[input.fieldMandatory.split(':')[0]] === input.fieldMandatory.split(':')[1]){
                    if (input.obligatorio) {
                        inputList.push(input.nombreId as never);
                    }
                }
            });
        });
        inputList
        return inputList;
    };

    const {
        register,
        control,
        handleSubmit,
        watch,
        formState: { errors, isValid },
    } = useForm<Inputs>({mode:"onChange"});
    const watchedValues = watch();
    
    useEffect(() => {
        createWizards();
    }, []);

    useEffect(() => {
        watchedValues["dataAuthorization"] && setHasNoAuthorization(watchedValues["dataAuthorization"].includes("No"));
    }, [watchedValues["dataAuthorization"]]);

    // Obtén el valor actual de services (puede ser array o string)
    const selectedServices = watchedValues["services"] || [];
    const mentorshipOptionValue = "servicio_3"; // El value real de la opción

    // ¿Está seleccionada la opción de mentoría?
    const showEnterpriseMentorship =
    Array.isArray(selectedServices)
        ? selectedServices.includes(mentorshipOptionValue)
        : selectedServices === mentorshipOptionValue;

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            setIsLoading(true);
            const token = await getToken();
            const formattedDate = new Date().toLocaleDateString('es-ES');

            const answers = Object.entries(data).map(([key, value]) => {
                if (key === "services") {
                    return {
                        contentfulId: key,
                        answer: data["services"].join(" | ")
                    };
                } else if (key === "RequiredForAntioquia" && data["RequiredForAntioquia"] === null) {
                    return {
                        contentfulId: key,
                        answer: ""
                    };
                } else if (key === "contactNumber") {
                    return {
                        contentfulId: key,
                        answer: `${data.countryCode || ""}${value}`
                    };
                } else if (key === "aditionalContactNumber") {
                    return {
                        contentfulId: key,
                        answer: `${data.aditionalCountryCode || ""}${value}`
                    };
                } else if ( key === "countryCode" || key === "aditionalCountryCode" ) {
                        // OMITIR estos campos, no retornes nada
                        return null;
                }
                return {
                    contentfulId: key,
                    answer: key === "registerDate"
                        ? formattedDate
                        : value,
                };
            }).filter(Boolean);

            const mappedData = {
                idForm: 2,
                answers,
            };

            saveForm(mappedData, token).then((response)=>{
                handleModalContent(response.data.status);
                setIsLoading(false);
                setIsOpenModal(true);
            });
        } catch (error) {
            handleModalContent(400);
            setIsLoading(false)
            setIsOpenModal(true);
        }
    }

    const blockName : string = "o-form-servicios";

    return(
        <>
            <section className={`${blockName}__header`}>
                <h1 className={`${blockName}__title`}>{props.tituloGeneral}</h1>
                <p className={`${blockName}__description ${activeStep >= 0 && blockName+"__description--left"}`}>{activeStep >= 0 ? props.tituloSeccion : "Proceso de inscripción"}</p>
                {window.innerWidth > 768 &&
                    <div className={`${blockName}__breadcrumb--border`}>
                        <Breadcrumb content={getPathSegments()} />
                    </div>
                }
                <p className={`${blockName}__titleWizard`}>{"Solicitud empresarial"}</p>
                {window.innerWidth > 768 && activeStep >= 0 &&
                    <FormWizard wizards={wizards} activeIndex={activeStep} setActiveIndex={setActiveStep} />
                }
                {activeStep >= 0 &&
                    <p className={`${blockName}__wizard-mobile-text`}>Paso {activeStep + 1} de {titulosFormulario.length}: <span className={`${blockName}__wizard-mobile-text--bold`}>{titulosFormulario[activeStep].tituloSeccion}</span></p>    
                }
                {window.innerWidth > 768 &&
                    <div className={`${blockName}__step-description`}>
                        {documentToReactComponents(titulosFormulario[activeStep].descripcion.json)}
                    </div>
                }
            </section>
            {window.innerWidth <= 768 && 
                activeStep >= 0 &&
                <>
                    <div className={`${blockName}__wizard-mobile_arrows-button-container`}>
                        <button type="button" className={`${blockName}__form-back-button`} onClick={()=> handleBack()}><img className={`${blockName}__form-back-arrow`} src={arrowLeft} alt="Flecha izquierda"/>Volver</button>
                        {activeStep < titulosFormulario.length-1 && (<button type="button" disabled={!isValid} className={`${blockName}__wizard-mobile_arrows-button`} onClick={()=> setActiveStep(activeStep+1)}>Paso {activeStep+1}<img className={`${blockName}__form-forward-arrow-magenta`} src={arrowLeft} alt="Flecha derecha"/></button>)}
                    </div>
                </>
            }
            <section className={blockName}>
                <div className={`${blockName}__form-container`}>
                    {titulosFormulario[activeStep].tituloGeneral && (
                        <h2 className={`${blockName}__form-container-title`}>
                            {titulosFormulario[activeStep].tituloGeneral}
                        </h2>
                    )}
                    <p className={`${blockName}__form-container-description`}>{documentToReactComponents(titulosFormulario[activeStep].descripcion.json)}</p>
                </div>
                {!isLoading && 
                    <form className={`${blockName}__form ${activeStep===1 && "o-form-servicios__form--line"}`} onSubmit={handleSubmit(onSubmit)}>
                        {titulosFormulario[activeStep].referenciaFormulario.map((input, index) => {
                                // Oculta la pregunta enterpriseMentorship si no corresponde
                            if ( input.nombreId === "enterpriseMentorship" && !showEnterpriseMentorship){
                                return null;
                            }
                            if(!input.deshabilitado && (!input.fieldMandatory || watchedValues[input.fieldMandatory.split(':')[0]] === input.fieldMandatory.split(':')[1])) {
                                let serviceOptions = {};
                                if(input.nombreId === "services") {
                                    serviceOptions = input.listaSelect.map((item)=>{
                                        return {label: item.split('|')[0], value:item.split('|')[1]}
                                    });
                                }
                                const typeAux = watchedValues["CompanyIdType"] === "DNI (Documento de Identificación Nacional) - Otros países" ? "text" : "number"
                                return(
                                    <FormInput
                                        key={`input-${input.nombreId}-${index}`}
                                        title={input.inputPrincipal}
                                        nombreId={input.nombreId}
                                        placeholder={input.placeholder? input.placeholder : ""}
                                        type={input.nombreId === "IdNumber"? typeAux :input.tipoCampo}
                                        maxCharacters={input.maximosCaracteres}
                                        isRequired={input.obligatorio}
                                        options={input.nombreId === "services" ? serviceOptions :input.listaSelect}
                                        icon={input.icon}
                                        listValue={[]}
                                        value=""
                                        setInputValue={()=>{}}
                                        register={register}
                                        isError={errors[input.nombreId]}
                                        tituloBotonTerminos={input.tituloBotonTerminos}
                                        textoTerminos={input.textoTerminos}
                                        ayuda={input.ayuda}
                                        seccion={input.seccion}
                                        errorMessage={input.tipoCampo === "email" ? input.mensajeError : ""}
                                        control={control}
                                    />
                                );
                            }
                        })}
                        {hasNoAuthorization && (
                            <ToastAdvertiser
                                imgSrc={warningSvg}
                                text="Para continuar debes aceptar el tratamiento de datos."
                                imgBgColor="#FF0000"
                            />
                        )}
                        {window.innerWidth >= 768 && <div></div>}
                        <div className={`${blockName}__form-cta-container-container`}>
                            <div className={`${blockName}__form-cta-container`}>
                                <button type="button" className={`${blockName}__form-back-cta`} onClick={()=> handleBack()}><img className={`${blockName}__form-back-arrow`} src={arrowLeft} alt="Flecha derecha"/> Volver</button>
                                {activeStep === titulosFormulario.length-1 ? <button type="submit" disabled={!isValid} className={`${blockName}__form-cta`}>Finalizar </button> : <button type="button" disabled={!isValid} className={`${blockName}__form-cta`} onClick={()=> setActiveStep(activeStep + 1)}>Continuar <img className={`${blockName}__form-forward-arrow`} src={arrowLeft} alt="Flecha derecha"/></button>}
                            </div>
                        </div>
                    </form>
                }
                <ProgressBar
                    formValues={watchedValues}
                    requiredValues={createInputGroupRequiredList()}
                />
            </section>
            {isLoading && (
                <div className="loading">
                    <Loading />
                </div>
            )}
            {isOpenModal && (
                <Modal
                    image={modalContent?.image ? modalContent.image : ""}
                    title={modalContent?.title ? modalContent.title : ""}
                    textButton={
                        modalContent?.textButton ? modalContent.textButton : ""
                    }
                    url={modalContent?.url ? modalContent.url : ""}
                >
                    <div className="o-form-solicitud-servicios__content-modal">
                        <p>{modalContent?.description ? modalContent.description : ""}</p>
                    </div>
                </Modal>
            )}
        </>
    )
}

export default FormSolicitudServiciosV2;